import * as React from "react";
import type { SVGProps } from "react";
const SvgTopLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="top_left_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M403.755 343.467h319.36a42.667 42.667 0 1 0 0-85.334H301.14a43.093 43.093 0 0 0-43.093 43.094V723.2a42.667 42.667 0 0 0 85.333 0V403.84l351.446 351.445c15.616 15.616 41.813 14.763 58.453-1.92 16.64-16.64 17.493-42.794 1.92-58.453L403.755 343.509z"
    />
  </svg>
);
export default SvgTopLeftIcon;
